export default "__VITE_PUBLIC_ASSET__1f48c52b__"